export function syncClientVersionCookie(cookies, currentVersion) {
  const storedVersion = +cookies.get('wd-version');

  if (!storedVersion || storedVersion !== currentVersion) {
    cookies.set('wd-version', currentVersion);
  }
}
